/// FOURJS_START_COPYRIGHT(D,2018)
/// Property of Four Js*
/// (c) Copyright Four Js 2018, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("NativeService", function (context, cls) {
  /**
   * Native Service to interact with native in UR mode
   * @namespace gbc.NativeService
   * @gbcService
   */
  class NativeService /** @lends gbc.NativeService */ {
    constructor() {
      this._activeNativeAction = {};
    }

    /**
     *
     * @param {{name:string, args:Array}} data
     */
    onNativeAction(data) {
      if (!data) {
        return;
      }
      const app = context.SessionService.getCurrent().getCurrentApplication();
      if (!app) {
        return;
      }
      let actionNode = null;
      this._activeNativeAction[data.name] = true;
      switch (data.name) {
        case "notificationpushed":
          app.scheduler.nativeNotificationPushedCommand();
          break;
        case "notificationselected":
          app.scheduler.nativeNotificationSelectedCommand();
          break;
        case "cordovacallback":
          app.scheduler.nativeCordovaCallbackCommand();
          break;
        case "back":
          app.scheduler.nativeBackCommand(data.args);
          break;
        case "close":
          app.scheduler.nativeCloseCommand();
          break;
        case "enterbackground":
          app.scheduler.enterBackgroundCommand();
          break;
        case "enterforeground":
          app.scheduler.enterForegroundCommand();
          break;
        default:
          // Fallback: trigger action as called
          actionNode = app.getActionApplicationService()?.getAction(data.name);
          if (actionNode) {
            app.scheduler.actionVMCommand(actionNode, {});
          }
          break;
      }
    }

    /**
     * Returns true if native action name has been executed at least once during application cycle lifetime
     * @param {string} actionName
     * @returns {boolean}
     */
    hasActiveNativeAction(actionName) {
      if (!this._activeNativeAction) {
        return false;
      }
      return !!this._activeNativeAction[actionName];
    }

    /**
     * Destroy handler
     * @param data
     */
    onDestroyEvent(data) {
      const session = context.SessionService.getCurrent(),
        app = session.getApplicationByProcId(data.procId);
      app.fail(data.content.message);
    }

    /**
     * Native End handler
     * @param {Object} data - contains everything requested to End the app
     */
    onNativeEnd(data) {
      if (!data) {
        return;
      }

      const {
        content: { message },
        procId
      } = data;

      // Get App with ProcId
      const session = context.SessionService.getCurrent(),
        app = session?.getApplicationByProcId(procId);
      // Stop app with message
      app?.stop(message);
    }

    /**
     * Gbc Call handler when Native wants to send data to GBC
     * @param data
     */
    onGbcCall(data) {
      if (!data) {
        return;
      }

      const {
        //procId,
        //content,
        content: { name, args }
      } = data;

      // According to name of the call, switch to correct method (replace with switch when more than 3 cases)
      switch (name) {
        case "clearStoredSettings":
          gbc.StoredSettingsService.reset();
          break;
        case "darkMode":
          // Ignore if current app is a child application
          if (gbc.SessionService.getCurrent().getCurrentApplication().getProcIdParent()) {
            break;
          }
          if (args?.enable) {
            gbc.ThemeService.loadTheme(gbc.ThemeService.getDarkSchemeName(gbc.ThemeService.getCurrentTheme()));
          } else {
            gbc.ThemeService.loadTheme(gbc.ThemeService.getLightSchemeName(gbc.ThemeService.getCurrentTheme()));
          }
          break;
        case "storedSettings":
          gbc.StoredSettingsService.enable(args.enable);
          break;
        case "updateFont":
          gbc.ThemeService.setFontData(args);
          break;
        case "logLevel":
          if (args.level < 3) {
            gbc.LogService.changeLevel("info");
          } else {
            gbc.LogService.changeLevel("debug");
          }
          break;
      }
    }

    /**
     * @inheritDoc
     */
    destroy() {
      this._activeNativeAction = null;
    }
  }

  gbc.NativeService = new NativeService();
});
